import { AttributesMixin, define, Store, type } from "@type-r/models"
import { CreditNoteBuyersLookup, CreditNoteSuppliersLookup } from "../../api/lookups"
import { CreditNotesFilters } from "./credit-notes-filters"

export interface CreditNotesStore extends AttributesMixin<typeof CreditNotesStore> { }
@define
export class CreditNotesStore extends Store {
  static attributes = {
    filter: type(CreditNotesFilters),
    suppliers: CreditNoteSuppliersLookup,
    buyers: CreditNoteBuyersLookup
  }

  initialize() {
    this.filter.suppliers.set({
        selected: [],
        placeholder: 'Supplier Name',
        options: Array.from(new Set(this.suppliers.items.map(x => x.name)))        
    })
    this.filter.buyers.set({
        selected: [],
        placeholder: 'Buyer Name',
        options: Array.from(new Set(this.buyers.items.map(x => x.name)))        
    })
  }
}  